document.addEventListener('DOMContentLoaded', () => {
  const wishlistContainer = document.getElementById('wishlist-main-product');

  if (!wishlistContainer) {
    console.error('Wishlist container not found');
    return;
  }

  wishlistContainer.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget.querySelector('.swym-button');
    if (button) {
      button.click();
    }
  });

  const wishlistIcons = wishlistContainer.querySelectorAll('svg');
  const swymButtonSelector = '.swym-button.swym-add-to-wishlist';

  const moveSwymButton = () => {
    const swymButton = document.querySelector(swymButtonSelector);
    if (swymButton) {
      wishlistContainer.innerHTML = '';

      wishlistIcons.forEach(icon => {
        wishlistContainer.appendChild(icon);
      });

      wishlistContainer.appendChild(swymButton);
      return true;
    }
    return false;
  };

  // Function to sync the swym-added class state
  const syncWishlistState = () => {
    const swymButton = document.querySelector(`${swymButtonSelector}.swym-added`);
    if (swymButton) {
      wishlistContainer.classList.add('swym-added');
    } else {
      wishlistContainer.classList.remove('swym-added');
    }
  };

  if (moveSwymButton()) {
    syncWishlistState();
  }

  // Observer for button placement
  const buttonObserver = new MutationObserver((mutations, obs) => {
    if (moveSwymButton()) {
      obs.disconnect();
      clearTimeout(buttonObserverTimeout);
      syncWishlistState();
      setupStateObserver();
    }
  });

  const buttonObserverTimeout = setTimeout(() => {
    buttonObserver.disconnect();
  }, 8000);

  buttonObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Setup observer for swym-added class changes
  const setupStateObserver = () => {
    const swymButton = document.querySelector(swymButtonSelector);
    if (!swymButton) return;

    const stateObserver = new MutationObserver(() => {
      syncWishlistState();
    });

    stateObserver.observe(swymButton, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };
});